// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   홈 — 서비스 · 소재 · 포털 · CTA
   ══════════════════════════════════════════════════════════════════ */

/* ── 서비스 카드 ─────────────────────────────────── */
.svc-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.svc {
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: inherit;
}

.svc-stage {
  position: relative;
  height: 236px;
  background: var(--sunk);
  border-bottom: 1px solid var(--line);
  display: grid;
  place-items: center;
  overflow: hidden;
}

.svc-stage .iso-glyph {
  transition: transform 0.35s var(--ease);
  filter: drop-shadow(0 12px 14px rgba(12, 17, 24, 0.12));
}

.svc:hover .svc-stage .iso-glyph {
  transform: translateY(-6px);
}

.svc-body {
  padding: 22px 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
}

.svc-body h3 {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.018em;
  margin-top: 2px;
}

.svc-body p {
  color: var(--ink-2);
  font-size: 14px;
  line-height: 1.6;
  flex: 1 1;
}

.svc-body .btn-link {
  margin-top: 8px;
  font-size: 14px;
}

/* 절단 스윕 — 호버 시 광선이 무대를 쓸고 지나간다 */
.iso-sweep {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}

.iso-sweep::before {
  content: "";
  position: absolute;
  top: -40%;
  left: -30%;
  width: 26px;
  height: 180%;
  background: linear-gradient(90deg, transparent, rgba(255, 107, 26, 0.85), transparent);
  filter: blur(3px);
  transform: rotate(26.565deg) translateX(-160px);
}

.svc:hover .iso-sweep {
  opacity: 1;
}

.svc:hover .iso-sweep::before {
  animation: isoSweep 0.9s var(--ease);
}

@keyframes isoSweep {
  to { transform: rotate(26.565deg) translateX(520px); }
}

@media (max-width: 960px) {
  .svc-grid {
    grid-template-columns: 1fr;
  }
  .svc-stage {
    height: 180px;
  }
}

/* ── 소재 ────────────────────────────────────────── */
.home-mat-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.9fr);
  gap: 48px;
  align-items: center;
}

.mat-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mat-row {
  display: grid;
  grid-template-columns: 1fr auto auto 18px;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid var(--line);
  border-radius: var(--r-2);
  background: var(--surface);
  transition: all var(--dur) var(--ease);
}

.mat-row:hover {
  border-color: var(--brand);
  transform: translate(-2px, -2px);
  box-shadow: var(--sh-iso);
}

.mat-name b {
  display: block;
  font-weight: 600;
  font-size: 15px;
}

.mat-name small {
  font-size: 12.5px;
}

.mat-range {
  font-size: 12.5px;
  color: var(--ink-2);
  text-align: right;
}

.mat-range small {
  display: block;
  font-size: 10.5px;
  color: var(--ink-3);
  letter-spacing: 0.06em;
}

.mat-arrow {
  color: var(--ink-4);
  transition: transform var(--dur), color var(--dur);
}

.mat-row:hover .mat-arrow {
  color: var(--brand);
  transform: translateX(2px);
}

.home-mat-art {
  height: 420px;
  display: grid;
  place-items: center;
  padding: 40px;
}

.home-mat-art .iso-svg {
  width: 100%;
  max-width: 440px;
  filter: drop-shadow(0 20px 22px rgba(12, 17, 24, 0.14));
}

@media (max-width: 960px) {
  .home-mat-grid {
    grid-template-columns: 1fr;
  }
  .home-mat-art {
    height: 320px;
    order: -1;
  }
  .mat-row {
    grid-template-columns: 1fr auto 18px;
  }
  .mat-lead {
    display: none;
  }
}

/* ── 포털 ────────────────────────────────────────── */
.home-portal-grid {
  display: grid;
  grid-template-columns: minmax(320px, 0.95fr) minmax(0, 1fr);
  gap: 56px;
  align-items: center;
}

.portal-mock {
  padding: 18px 20px;
  transform: rotate(-1.2deg);
}

.portal-mock-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.portal-row {
  display: grid;
  grid-template-columns: 1.1fr 1.2fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--line-2);
  font-size: 13.5px;
}

.portal-row .mono {
  font-size: 12.5px;
  color: var(--ink-2);
}

.portal-mock-foot {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: var(--r-2);
  background: var(--surface-2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.portal-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 24px;
}

.portal-features li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.portal-features b {
  display: block;
  font-weight: 600;
  font-size: 15px;
}

.portal-features p {
  color: var(--ink-3);
  font-size: 13.5px;
  margin-top: 2px;
  line-height: 1.5;
}

@media (max-width: 960px) {
  .home-portal-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .portal-mock {
    transform: none;
  }
}

@media (max-width: 560px) {
  .portal-features {
    grid-template-columns: 1fr;
  }
  .portal-row {
    grid-template-columns: 1fr auto;
  }
  .portal-row > span:nth-child(2) {
    display: none;
  }
}

/* ── CTA ─────────────────────────────────────────── */
.home-cta {
  position: relative;
  overflow: hidden;
  background: var(--ink);
  color: #fff;
  padding: 88px 0;
}

.home-cta .iso-grid-bg {
  --iso-grid: rgba(255, 255, 255, 0.09);
  opacity: 1;
}

.home-cta-in {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.home-cta h2 {
  color: #fff;
  font-size: var(--t-h2);
  font-weight: 800;
  letter-spacing: -0.028em;
  margin-top: 14px;
}

.home-cta p {
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.66);
  max-width: 50ch;
  font-size: 15px;
}

.home-cta-btns {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.home-cta-ghost {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.28);
}

.home-cta-ghost:hover {
  background: rgba(255, 255, 255, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA;;uEAEuE;;AAEvE,kDAAkD;AAClD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,KAAK,8CAA8C,EAAE;AACvD;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;AACF;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\n   홈 — 서비스 · 소재 · 포털 · CTA\n   ══════════════════════════════════════════════════════════════════ */\n\n/* ── 서비스 카드 ─────────────────────────────────── */\n.svc-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n\n.svc {\n  padding: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  color: inherit;\n}\n\n.svc-stage {\n  position: relative;\n  height: 236px;\n  background: var(--sunk);\n  border-bottom: 1px solid var(--line);\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.svc-stage .iso-glyph {\n  transition: transform 0.35s var(--ease);\n  filter: drop-shadow(0 12px 14px rgba(12, 17, 24, 0.12));\n}\n\n.svc:hover .svc-stage .iso-glyph {\n  transform: translateY(-6px);\n}\n\n.svc-body {\n  padding: 22px 24px 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.svc-body h3 {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.018em;\n  margin-top: 2px;\n}\n\n.svc-body p {\n  color: var(--ink-2);\n  font-size: 14px;\n  line-height: 1.6;\n  flex: 1;\n}\n\n.svc-body .btn-link {\n  margin-top: 8px;\n  font-size: 14px;\n}\n\n/* 절단 스윕 — 호버 시 광선이 무대를 쓸고 지나간다 */\n.iso-sweep {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.iso-sweep::before {\n  content: \"\";\n  position: absolute;\n  top: -40%;\n  left: -30%;\n  width: 26px;\n  height: 180%;\n  background: linear-gradient(90deg, transparent, rgba(255, 107, 26, 0.85), transparent);\n  filter: blur(3px);\n  transform: rotate(26.565deg) translateX(-160px);\n}\n\n.svc:hover .iso-sweep {\n  opacity: 1;\n}\n\n.svc:hover .iso-sweep::before {\n  animation: isoSweep 0.9s var(--ease);\n}\n\n@keyframes isoSweep {\n  to { transform: rotate(26.565deg) translateX(520px); }\n}\n\n@media (max-width: 960px) {\n  .svc-grid {\n    grid-template-columns: 1fr;\n  }\n  .svc-stage {\n    height: 180px;\n  }\n}\n\n/* ── 소재 ────────────────────────────────────────── */\n.home-mat-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.9fr);\n  gap: 48px;\n  align-items: center;\n}\n\n.mat-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mat-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto 18px;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 16px;\n  border: 1px solid var(--line);\n  border-radius: var(--r-2);\n  background: var(--surface);\n  transition: all var(--dur) var(--ease);\n}\n\n.mat-row:hover {\n  border-color: var(--brand);\n  transform: translate(-2px, -2px);\n  box-shadow: var(--sh-iso);\n}\n\n.mat-name b {\n  display: block;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.mat-name small {\n  font-size: 12.5px;\n}\n\n.mat-range {\n  font-size: 12.5px;\n  color: var(--ink-2);\n  text-align: right;\n}\n\n.mat-range small {\n  display: block;\n  font-size: 10.5px;\n  color: var(--ink-3);\n  letter-spacing: 0.06em;\n}\n\n.mat-arrow {\n  color: var(--ink-4);\n  transition: transform var(--dur), color var(--dur);\n}\n\n.mat-row:hover .mat-arrow {\n  color: var(--brand);\n  transform: translateX(2px);\n}\n\n.home-mat-art {\n  height: 420px;\n  display: grid;\n  place-items: center;\n  padding: 40px;\n}\n\n.home-mat-art .iso-svg {\n  width: 100%;\n  max-width: 440px;\n  filter: drop-shadow(0 20px 22px rgba(12, 17, 24, 0.14));\n}\n\n@media (max-width: 960px) {\n  .home-mat-grid {\n    grid-template-columns: 1fr;\n  }\n  .home-mat-art {\n    height: 320px;\n    order: -1;\n  }\n  .mat-row {\n    grid-template-columns: 1fr auto 18px;\n  }\n  .mat-lead {\n    display: none;\n  }\n}\n\n/* ── 포털 ────────────────────────────────────────── */\n.home-portal-grid {\n  display: grid;\n  grid-template-columns: minmax(320px, 0.95fr) minmax(0, 1fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.portal-mock {\n  padding: 18px 20px;\n  transform: rotate(-1.2deg);\n}\n\n.portal-mock-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.portal-row {\n  display: grid;\n  grid-template-columns: 1.1fr 1.2fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid var(--line-2);\n  font-size: 13.5px;\n}\n\n.portal-row .mono {\n  font-size: 12.5px;\n  color: var(--ink-2);\n}\n\n.portal-mock-foot {\n  margin-top: 12px;\n  padding: 12px 14px;\n  border-radius: var(--r-2);\n  background: var(--surface-2);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.portal-features {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px 24px;\n}\n\n.portal-features li {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.portal-features b {\n  display: block;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.portal-features p {\n  color: var(--ink-3);\n  font-size: 13.5px;\n  margin-top: 2px;\n  line-height: 1.5;\n}\n\n@media (max-width: 960px) {\n  .home-portal-grid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n  .portal-mock {\n    transform: none;\n  }\n}\n\n@media (max-width: 560px) {\n  .portal-features {\n    grid-template-columns: 1fr;\n  }\n  .portal-row {\n    grid-template-columns: 1fr auto;\n  }\n  .portal-row > span:nth-child(2) {\n    display: none;\n  }\n}\n\n/* ── CTA ─────────────────────────────────────────── */\n.home-cta {\n  position: relative;\n  overflow: hidden;\n  background: var(--ink);\n  color: #fff;\n  padding: 88px 0;\n}\n\n.home-cta .iso-grid-bg {\n  --iso-grid: rgba(255, 255, 255, 0.09);\n  opacity: 1;\n}\n\n.home-cta-in {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n\n.home-cta h2 {\n  color: #fff;\n  font-size: var(--t-h2);\n  font-weight: 800;\n  letter-spacing: -0.028em;\n  margin-top: 14px;\n}\n\n.home-cta p {\n  margin-top: 12px;\n  color: rgba(255, 255, 255, 0.66);\n  max-width: 50ch;\n  font-size: 15px;\n}\n\n.home-cta-btns {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.home-cta-ghost {\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.28);\n}\n\n.home-cta-ghost:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
